import React, {Fragment} from 'react';
import Header from '../../components/header'
// import PageTitle from '../../components/pagetitle'
// import Casesection from '../../components/case2'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import Awards from '../../components/awards'
import awardImg from '../../images/awards.jpg'

const AboutPage =() => {
    return(
        <Fragment>
            <Header/>
            {/* <PageTitle pageTitle={'Awards'} pagesub={'Awards'}/>  */}
            {/* <Mission subclass={'section-padding'}/> */}
            <Awards highlightImage={awardImg}/>
            {/* <Casesection/> */}
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};
export default AboutPage;
